// Hora del servidor, para los contadores "hace X min". Si se usara solo el
// reloj del dispositivo, un celular desfasado mostraría tiempos mal (un
// pedido "del futuro" queda eternamente en "hace unos segundos"). Cada
// respuesta del API trae el header `Date` con la hora del servidor: se guarda
// la diferencia y se aplica a Date.now().
let offsetMs = 0;

export function syncServerClock(response) {
  const header = response?.headers?.get("Date");
  const serverTime = header ? Date.parse(header) : NaN;
  if (Number.isNaN(serverTime)) return;
  // El header tiene precisión de segundos y la respuesta tarda en llegar:
  // diferencias chicas son ruido. Solo se corrige un desfase real (> 1 min).
  const diff = serverTime - Date.now();
  offsetMs = Math.abs(diff) > 60000 ? diff : 0;
}

export function serverNow() {
  return Date.now() + offsetMs;
}

export function getClockOffsetMs() {
  return offsetMs;
}

// `?debug=1` en la URL activa el diagnóstico del contador en la pantalla
// del Cliente (se recuerda durante la sesión; `?debug=0` lo apaga).
export function isClockDebug() {
  try {
    const param = new URLSearchParams(window.location.search).get("debug");
    if (param !== null) sessionStorage.setItem("clockDebug", param);
    return sessionStorage.getItem("clockDebug") === "1";
  } catch (error) {
    return false;
  }
}

// Diagnóstico (?debug=1): cuántas veces corrió cada disparador de usePolling
// y cuándo fue la última — para saber si en un dispositivo los timers corren
// o solo refresca por toques / al volver a primer plano.
const pollingStats = { timer: 0, resume: 0, touch: 0, start: 0, lastTimerAt: null };

export function recordPollingTick(source) {
  pollingStats[source] = (pollingStats[source] || 0) + 1;
  if (source === "timer") pollingStats.lastTimerAt = new Date();
}

export function getPollingStats() {
  return pollingStats;
}
